module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapterHead",
    attrs: {
      "id": "Table_of_Contents"
    }
  }, [_c('h2', {
    staticClass: "chapterTitle3"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry2"
  }, [_c('a', {
    attrs: {
      "href": "#/03_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry2"
  }, [_c('a', {
    attrs: {
      "href": "#/04_Photograph_Sources"
    }
  }, [_vm._v("Photograph Source")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry2"
  }, [_c('a', {
    attrs: {
      "href": "#/05_Introduction"
    }
  }, [_vm._v("Introduction: The Road to Barbarossa")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('a', {
    attrs: {
      "href": "#/06_00_Chapter_One"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/06_00_Chapter_One"
    }
  }, [_vm._v("Stalin’s Armoured Fist")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/07_00_Chapter_Two",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/07_00_Chapter_Two",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hitler’s Axis Armour")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/08_00_Chapter_Three",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/08_00_Chapter_Three",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Barbarossa – The Red Army Smashed")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/09_00_Chapter_Four",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/09_00_Chapter_Four",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zhukov’s Moscow Miracle")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/10_00_Chapter_Five",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/10_00_Chapter_Five",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Timoshenko’s Kharkov Riposte")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_00_Chapter_Six",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/11_00_Chapter_Six",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Disaster at Stalingrad")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/12_00_Chapter_Seven",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/12_00_Chapter_Seven",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manstein’s Kharkov Comeback")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_00_Chapter_Eight",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/13_00_Chapter_Eight",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clash of the Titans – Kursk")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_00_Chapter_Nine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/14_00_Chapter_Nine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalin’s Steamroller – Bagration")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/15_00_Chapter_Ten",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/15_00_Chapter_Ten",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T-34s on the Oder")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/16_00_Chapter_Eleven",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/16_00_Chapter_Eleven",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seelow and the Last Tank Battle")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12987ef4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/02_Table_of_Contents.vue
// module id = 63
// module chunks = 0